import { actions, withAuth } from 'store';
import { checkAuthStrategyLoginRedirect, getNextPath } from 'lib/auth';
import { Login } from 'components/login';

import { NextPage } from 'next';

interface Props {
  next?: string | null;
}

const LoginPage: NextPage<Props> = ({ next }) => <Login next={next} />;

LoginPage.getInitialProps = async ({ asPath, reduxStore, res, query }) => {
  const next = query.next ? getNextPath(asPath) : null;

  if (query.action !== 'logout') {
    const redirect = checkAuthStrategyLoginRedirect({ next, reduxStore, res });
    if (redirect) return {};
  }

  reduxStore.dispatch(actions.setInitialPageState({}));
  return { next };
};

export default withAuth(['PUBLIC'])(LoginPage);
